import React, {Fragment, PureComponent, ReactNode} from 'react';
import InputError from 'app/components/deposit/InputError';
import PaymentSystemInterface from 'app/interfaces/PaymentSystemInterface';
import ErrorsServerInterface from 'app/interfaces/ErrorsServerInterface';
import AmountInput from '../reusable/AmountInput';

interface InputWalletProps {
    accountLabel: string
    selectedSystem: PaymentSystemInterface
    errors: ErrorsServerInterface
    accountValue: string
    updateWalletAccount: (account: string) => void
}

export default class InputWallet extends PureComponent<InputWalletProps> {
    componentDidUpdate(prevProps: InputWalletProps): void {
        if (prevProps.selectedSystem?.id !== this.props.selectedSystem?.id) {
            this.props.updateWalletAccount('');
        }
    }

    get isDisabled(): boolean {
        return !this.props.selectedSystem.input_wallet;
    }

    onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>): void => {
        this.props.updateWalletAccount(e.target.value);
    };

    onKeyUpHandler = (e: React.KeyboardEvent<HTMLInputElement>): void => {
        const target = e.target as HTMLInputElement;
        this.props.updateWalletAccount(target.value);
    };

    render(): ReactNode {
        const {accountValue, errors, selectedSystem, accountLabel} = this.props;
        return <Fragment>
            <label className="form__row-label" htmlFor="wallet.account">{accountLabel}</label>
            <div className={`field ${errors['wallet.account'] ? 'field-error' : ''}`}>
                <AmountInput
                    key={selectedSystem.id}
                    containerClassName="field__wrap"
                    value={accountValue}
                    className="field__input"
                    onChange={this.onChangeHandler}
                    placeholder={selectedSystem.wallet_placeholder}
                    disabled={this.isDisabled}
                    onKeyUp={this.onKeyUpHandler}
                    name="wallet.account"
                >
                    {errors['wallet.account'] && <InputError error={errors['wallet.account']}/>}
                </AmountInput>
            </div>
        </Fragment>;
    }
}
